import { data } from '../../svg/Send/data';
import { makeIcon } from '../makeIcon';

export const Send = makeIcon(data, 'send', 'Send');

export default Send;
